import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NeedlMark from '../Brand/NeedlMark';
import { tokens } from '../../theme';

const footerLinks = [
  { label: 'Market', to: '/market' },
  { label: 'Services', to: '/services' },
  { label: 'Terms', to: '/terms' },
  { label: 'Privacy', to: '/privacy' },
];

export default function Footer() {
  return (
    <Box component="footer" sx={{ mt: 'auto', borderTop: `1px solid ${tokens.line}` }}>
      <Container maxWidth={false} sx={{ px: { xs: 2, md: 3 }, py: 1.5 }}>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', rowGap: 1 }}>
          <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
            <NeedlMark sx={{ fontSize: 22, color: tokens.mint }} />
            <Typography variant="caption" color="text.secondary">
              © {new Date().getFullYear()} needL · Snap it. Sell it. Delivered.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={2}>
            {footerLinks.map((link) => (
              <Link key={link.to} component={RouterLink} to={link.to} underline="hover" variant="caption" sx={{ color: tokens.textMuted, fontWeight: 600 }}>
                {link.label}
              </Link>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
